import { render, staticRenderFns } from "./StudentHomeworkBarChart.vue?vue&type=template&id=6324bb06"
import script from "./StudentHomeworkBarChart.vue?vue&type=script&lang=js"
export * from "./StudentHomeworkBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports